import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
import API from '../api';
import {
  Box
} from 'grommet';
import Content from '../utils/RenderContent';
import Analytics from '../utils/Analytics';
import RenderHelmet from '../utils/RenderHelmet';
import PageWrap from "../components/PageWrap";

const GenericPage = (props) => {
    const { match, t, i18n } = props;
    const [content, setContent] = useState(false);

    // Load the page content
    const loadHomeContent = () => {
      API.getPageBySlug(i18n, props.slug).then( (res) => {
        var inlineContent = res.items[0];
        setContent(inlineContent);
      })
      .catch(console.error)
    }

    // track google Page view
    useEffect(() => {
      Analytics.TrackPageView(window.location.pathname)
      loadHomeContent()
    }, []);

    return (
      <Box id="page">
        <RenderHelmet content={content} match={match} t={t} i18n={i18n} />
        <PageWrap content={content}>
          <Content content={content} match={match} t={t} i18n={i18n} />
        </PageWrap>
      </Box>
    );
}

const GenericPageTranslated = withTranslation("translations")(GenericPage);
export default GenericPageTranslated
